import Component from '../core/Component';
import GoogleMapsLoader from 'google-maps';
import { GOOGLE_MAPS_API_KEY } from '../core/config';
import { createMarker } from './Marker';

GoogleMapsLoader.KEY = GOOGLE_MAPS_API_KEY;

export default class GoogleMap extends Component {

    constructor(element) {
        super(element);

        this.markers = [];
        this.cache = {};

        this.google = null;
        this.cluster = null;

        this.clusterOptions = {
            cssClass: 'Cluster',
            width: 36,
            height: 36
        };

        GoogleMapsLoader.load(::this.handleGoogleMapsLoad);

        this.infoWindow = null;
        this.infoWindowId = null;

        this._onMarkerClick = id => {};
    }

    handleGoogleMapsLoad(google) {
        this.google = google;
        this.map = new google.maps.Map(this.element, {
            //center: latlng,
            zoom: 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [{"featureType":"all","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"color":"#8aa49f"},{"visibility":"on"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"administrative.neighborhood","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"landscape.natural","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"visibility":"on"},{"gamma":"3.32"}]},{"featureType":"landscape.natural.landcover","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"landscape.natural.terrain","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"transit.station","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"geometry","stylers":[{"visibility":"on"}]}]
        });

        this.map.addListener('bounds_changed', ::this.handleBoundsChange);

        this.points = JSON.parse(this.element.dataset.points);

        this.show(this.points);
    }

    handleBoundsChange() {
        if (this.infoWindow) {
            this.infoWindow.close();
        }
    }

    show(points) {
        if (points.length === 0) {
            return;
        }

        const google = this.google;
        const Marker = createMarker(google);

        this.points = points;

        this.markers = points.map(point => {
            const latlng = new google.maps.LatLng(point.lat, point.lng);

            const classes = ['lunch-Score', 'lunch-Score--pointer'];

            if (point.rating >= 4) {
                classes.push('is-good')
            } else if (point.rating >= 3) {
                // do nothing
            } else if (point.rating >= 2) {
                classes.push('is-average')
            } else {
                classes.push('is-bad')
            }

            const marker = new Marker({
                position: latlng,
                map: this.map,
                data: {
                    ...point
                },
                template: `
                    <div class="${classes.join(' ')}">
                        <b>${point.rating.toLocaleString()}</b>/5
                    </div>
                `,
                className: 'lunch-Marker',
                onClick: markerInstance => {
                    this._onMarkerClick(markerInstance);
                }
            });

            return marker;
        });

        this.render();
    }

    render() {
        if (!this.google) {
            return;
        }

        if (this.markers.length === 0) {
            return;
        }

        this.fit();
    }

    fit() {
        const latitudes = this.points.map(point => point.lat);
        const longitudes = this.points.map(point => point.lng);

        const minLat = Math.min(...latitudes);
        const maxLat = Math.max(...latitudes);

        const minLng = Math.min(...longitudes);
        const maxLng = Math.max(...longitudes);

        const southWest = new google.maps.LatLng(minLat, minLng);
        const northEast = new google.maps.LatLng(maxLat, maxLng);

        const bounds = new google.maps.LatLngBounds(southWest, northEast);

        this.map.fitBounds(bounds);
    }

    focus(id) {
        if (id in this.cache) {
            const index = this.cache[id];
            const marker = this.markers[index];
            const latlng = marker.getPosition();
            this.map.setZoom(14);
            this.map.panTo(latlng);
            this.showInfoWindow(marker);
        }
    }

    resize() {
        if (!this.google) {
            return
        }

        this.google.maps.event.trigger(this.map, 'resize')
        this.fit()
    }

    onMarkerClick(callback) {
        this._onMarkerClick = callback;
    }

}